<script setup>
import DashboardStatsAdminCard from '@/Components/Dashboard/DashboardStatsAdminCard'
import MoneyIcon from '@/icons/MoneyIcon'

import { computed } from 'vue'

const props = defineProps({
	invoices: {
		type: Array,
		default: null,
	},
})

const next30Days = computed(() => {
	if (props.invoices === null) return 0
	return props.invoices
		.filter(invoice => invoice.Status === 'AUTHORISED')
		.filter(invoice => {
			const dueDate = new Date(invoice.DueDate)
			const today = new Date()
			const thirtyDays = new Date()
			thirtyDays.setDate(today.getDate() + 30)
			return dueDate >= today && dueDate <= thirtyDays
		})
})

const next30Amount = computed(() => {
	if (props.invoices === null) return 0
	return next30Days.value
		.reduce((acc, invoice) => acc + invoice.AmountDue, 0)
})
</script>
<template>
	<BlockLoader class="h-64 w-full" v-if="invoices === null" />
	<DashboardStatsAdminCard
		:icon=MoneyIcon
		v-if="invoices"
		:data="next30Days.length"
		:caption="next30Days.length == 1 ? 'Invoice due soon' : 'Invoices due soon'"
		linkText="Go To Invoices"
		:href="route('dashboard.invoices.index')"
		class="text-center"
	>
		<p v-if="next30Amount" class="text-xs bg-Blue text-white px-2 py-1 rounded-xl mt-2">
			${{ next30Amount.toFixed(2) }}<br /> 30 day forecast
		</p>
	</DashboardStatsAdminCard>
</template>